import { EditableFieldNode } from './editable-field-node.model';

export class EditableFieldSection {
	public id: string;
	public label: string;
	public expanded: boolean = false;
	public items?: EditableFieldNode[];
	public isEditing = false;
	public rank?: number;
	public caseId?: string;
	public accountId?: string;
	public nodeType = 'section';

	constructor(params?: EditableFieldSectionParams) {
		this.id = params?.id;
		this.label = params?.label;
		this.items = params?.items;
		this.items?.forEach((item) => {
			item.parentId = this.id;
		});
	}
}

interface EditableFieldSectionParams{
	id: string;
	label: string;
	items?: EditableFieldNode[];
	rank?: number;
}

export type EditableField = EditableFieldNode | EditableFieldSection;
